import { type ReactElement, type ReactNode } from 'react';
import { s } from '@/theme/tokens';
import { Box, Text } from '@/ui';
import { TextField } from '@/ui/primitives/TextField';

type ProjectCsvMappingFieldRowProps = {
  label: string;
  value: string;
  placeholder: string;
  adornment: ReactNode;
  onChange: (nextValue: string) => void;
};

const mappingFieldRowLabelWidth = '92px';
const mappingFieldRowValidationWidth = '24px';

export const ProjectCsvMappingFieldRow = ({
  label,
  value,
  placeholder,
  adornment,
  onChange,
}: ProjectCsvMappingFieldRowProps): ReactElement => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: `${mappingFieldRowLabelWidth} minmax(0, 1fr) ${mappingFieldRowValidationWidth}`,
      alignItems: 'center',
      columnGap: s('md'),
      width: '100%',
      minWidth: 0,
    }}
  >
    <Text
      role="body"
      sx={(theme) => ({
        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: theme.typography.subtitle1.lineHeight,
        whiteSpace: 'nowrap',
      })}
    >
      {label}
    </Text>
    <TextField
      fieldStyle="settings"
      value={value}
      placeholder={placeholder}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      sx={{
        minWidth: 0,
        '& .MuiInputBase-root': { width: '100%' },
      }}
    />
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minWidth: mappingFieldRowValidationWidth,
      }}
    >
      {adornment}
    </Box>
  </Box>
);
